import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Currency helpers
export const findCurrency = (list, code) =>
  list?.find((c) => c.code === code) || null;

export const fmtMoney = (amount, currency) => {
  if (!currency) return String(amount);
  const n = Number(amount || 0);
  return `${currency.symbol}${n.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })} ${currency.code}`;
};
